// Generated by CoffeeScript 2.7.0
var Admin__Messages__SettingsController;

import SettingsPanel from '../concerns/settings_panel.js';

import MessageNavActions from './concerns/message_nav_actions.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import OrganizationSearch from 'trunks/vue/admin/components/search/organization.js';

import CollaboratorsSelection from 'trunks/vue/admin/compositions/collaborators_selection.js';

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

import PrimaryFieldOptions from 'trunks/vue/admin/compositions/primary_field_options.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default Admin__Messages__SettingsController = (function() {
  class Admin__Messages__SettingsController extends Skylark.App.BaseController {
    constructor() {
      var dataclip, dataclipable_gid;
      super();
      this.__toggleNavMenu();
      this.gid = new Skylark.Libs.GlobalID(this.getVars('gid'));
      if (dataclip = _.clone(this.getVars('dataclip'))) {
        dataclipable_gid = new Skylark.Libs.GlobalID(this.getVars('dataclipable_gid'));
        Skylark.App.Controllers.find('Admin::ResponsesController').prototype._setupDataclipsNavigation(dataclip, dataclipable_gid);
      }
    }

    base() {
      if (!this.getVars('readonly')) {
        this._initDropdownSelect();
        return this._initCommentEnableSettings();
      }
    }

    auto_close() {
      if (!this.getVars('readonly')) {
        this._initSwitchElement();
        return this._initDatetimepicker();
      }
    }

    after_commit() {
      var _toggleDropdownSelectView, dropdown_richtext_el, dropdown_url_el, form;
      form = DomMaster.find('.edit_form');
      dropdown_url_el = form.find('.js-dropdown-url');
      dropdown_richtext_el = form.find('.js-dropdown-richtext');
      _toggleDropdownSelectView = function(judge) {
        switch (judge) {
          case 'show_message':
            dropdown_richtext_el.show();
            return dropdown_url_el.hide();
          case 'redirect':
            dropdown_richtext_el.hide();
            return dropdown_url_el.show();
          default:
            dropdown_richtext_el.hide();
            return dropdown_url_el.hide();
        }
      };
      _toggleDropdownSelectView(form.find('#form_after_submit_action').node.value);
      if (this.getVars('readonly')) {
        return;
      }
      this._initDropdownSelect(_toggleDropdownSelectView);
      this._initDisplayFieldsSetting();
      return _.each(form.findAll('.js-richtext-toggle'), function(item) {
        item.input = item.find('.js-richtext-input').node;
        item.find('.richtext_el').node.innerHTML = item.input.value || '<p class="placeholder">请在此编辑</p>';
        return item.node.addEventListener('click', function(event) {
          if (item.editor) {
            return;
          }
          item.find('.richtext_el').node.innerHTML = item.input.value || '';
          item.editor = new Skylark.Elements.Editor(item.find('.richtext_el').node, {
            placeholder: '请在此编辑'
          });
          item.addClass('floated');
          return item.editor.editor.$on('valueChanged', function(value) {
            return item.input.value = value;
          });
        }, false);
      });
    }

    red_packet() {
      var default_view, display_container, random_view;
      display_container = DomMaster.find('.setting-display-container');
      default_view = display_container.find('.js-default-view');
      random_view = display_container.find('.js-random-view');
      if (display_container.find('.js-random-toggle').node.checked) {
        random_view.show();
        default_view.hide();
      } else {
        default_view.show();
        random_view.hide();
      }
      this._initSwitchElement();
      if (this.getVars('readonly')) {
        return;
      }
      display_container.node.proxy('change', '.js-random-toggle', function(event) {
        default_view.toggle();
        return random_view.toggle();
      });
      return this._initDatetimepicker();
    }

    dataclip() {
      var admin_dataclip_url, collaborator_ids, collaborators_el, collaborators_selection_vm, form_el, organization_search_vm, title_el, user_boundary, user_boundary_el;
      admin_dataclip_url = `/admin${this.gid.toPath()}`;
      user_boundary = _.pick(_.clone(this.getVars('user_boundary')), 'id', 'organization_ids');
      collaborator_ids = _.clone(this.getVars('collaborator_ids'));
      form_el = DomMaster.find('.dataclip-setting-form');
      title_el = form_el.find('#js_dataclip_setting_title');
      user_boundary_el = form_el.find('#js_dataclip_setting_user_boundary');
      collaborators_el = form_el.find('#js_dataclip_setting_collaborators');
      organization_search_vm = new OrganizationSearch({
        el: user_boundary_el.node,
        propsData: {
          remote: `${admin_dataclip_url}/user_boundaries/organizations/query?enhanced=true`,
          resources: `${admin_dataclip_url}/user_boundaries/organizations`,
          eagerLoadChildren: true,
          selectedOrganizationIds: user_boundary.organization_ids,
          organizationNameSuffix: '及以下组织',
          countingOrganizations: true,
          readonly: this.getVars('readonly')
        }
      });
      organization_search_vm.$on('valueChanged', function(vm) {
        return user_boundary.organization_ids = _.pluck(vm.selectedItems, 'composedId');
      });
      collaborators_selection_vm = new CollaboratorsSelection({
        el: collaborators_el.node,
        propsData: {
          initialCollaboratorIds: this.getVars('collaborator_ids'),
          extendClass: 'dataclip-form-collaborators',
          readonly: this.getVars('readonly')
        }
      });
      collaborators_selection_vm.$on('valueChanged', function(value) {
        return collaborator_ids = value;
      });
      return form_el.node.proxy('click', '#js_dataclip_setting_save_btn', function() {
        var attrs;
        attrs = _.tap({
          title: title_el.node.value,
          collaborator_ids: collaborator_ids
        }, function(obj) {
          if ((user_boundary.id != null) || _.any(user_boundary.organization_ids)) {
            return obj.user_boundary_attributes = _.pick(user_boundary, 'organization_ids');
          }
        });
        return Skylark.Libs.Ajax.patch(admin_dataclip_url, {
          contentType: 'application/json, text/javascript',
          responseType: 'script',
          data: {
            dataclip: attrs
          }
        });
      });
    }

    primary_field_id() {
      var fields, gid, options, primary_field_el, primary_field_id;
      primary_field_el = DomMaster.find('#primary-field-id');
      ({fields, gid, primary_field_id} = this.getVars());
      options = _.map(fields, function(item) {
        var field;
        field = {
          name: item.title,
          id: item.id,
          _selected: item.id === primary_field_id
        };
        return field;
      });
      return new PrimaryFieldOptions({
        el: primary_field_el.node,
        data: {
          options: options
        },
        propsData: {
          datableGID: new Skylark.Libs.GlobalID(gid)
        }
      });
    }

    _initDatetimepicker() {
      var datetime_picker_input_el;
      datetime_picker_input_el = DomMaster.find('.js-datetime-picker-input');
      return new Skylark.Elements.DatetimePickerPopover(DomMaster.find('#js_datetimepicker_popover'), {
        initValue: datetime_picker_input_el.node.value,
        ensureCallback: function(value) {
          return datetime_picker_input_el.node.value = value != null ? value.strftime() : void 0;
        }
      });
    }

    _initSwitchElement() {
      var display_container, switch_element;
      display_container = DomMaster.find('.setting-display-container');
      return switch_element = new Skylark.Elements.Switch(DomMaster.find('.js-switch-input'), {
        runCallbacksOnCreate: true,
        switchOnFunc: function() {
          return display_container.removeClass('disabled');
        },
        switchOffFunc: function() {
          return display_container.addClass('disabled');
        }
      });
    }

    _initDropdownSelect(toggleViewFun) {
      return _.each(DomMaster.findAll('.dropdown-select'), function(select_el) {
        var dropdown_input;
        dropdown_input = select_el.find('.js-dropdown-input');
        return new Skylark.Elements.DropdownSelect(select_el, function(active_option_item) {
          dropdown_input.node.value = active_option_item.node.data('value');
          return typeof toggleViewFun === "function" ? toggleViewFun(active_option_item.node.data('value')) : void 0;
        });
      });
    }

    _initDisplayFieldsSetting() {
      var fields, init_values, readonly, value_input;
      fields = $currentController.getVars('candidate_marked_fields');
      value_input = DomMaster.find('.js-display-fields-value');
      readonly = value_input.node.hasAttribute('readonly');
      init_values = value_input.node.getAttribute('value').split(',');
      fields = this.__groupFields(fields, init_values);
      return new FilterOptions({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('display_fields_setting_container'),
        propsData: {
          groupedOptions: fields,
          multiple: true,
          disabled: readonly,
          maxSelectedOptionsLength: 4
        }
      // placeholder: '显示所有字段'
      // TODO: refactor placeholder
      }).$on('valueChanged', function(vm) {
        return value_input.node.setAttribute('value', _.pluck(vm.selectedOptions, 'id'));
      }).$on('valueError', function() {
        return newAlertify('最多显示4个字段', {
          type: 'error'
        });
      });
    }

    _initCommentEnableSettings() {
      var comment_auto_approved_input_el, comment_closed_input_el, comment_enable_checkbox_el, comment_must_approved_input_el, comment_sub_options_el, comment_type_radio_el;
      comment_enable_checkbox_el = DomMaster.find('.js-comment-status input[type=checkbox]').node;
      comment_sub_options_el = DomMaster.find('.sub-options');
      comment_type_radio_el = DomMaster.find('.js-comments-type-radio');
      comment_closed_input_el = comment_type_radio_el.find('.js-comment-status-comment_closed input[type=radio]');
      comment_auto_approved_input_el = comment_type_radio_el.find('.js-comment-status-comment_auto_approved input[type=radio]');
      comment_must_approved_input_el = comment_type_radio_el.find('.js-comment-status-comment_must_approved input[type=radio]');
      return comment_enable_checkbox_el.proxy('click', function(event) {
        if (comment_enable_checkbox_el.checked) {
          comment_sub_options_el.show();
          if (!comment_auto_approved_input_el.node.checked) {
            return comment_must_approved_input_el.node.checked = true;
          }
        } else {
          comment_sub_options_el.hide();
          return comment_closed_input_el.node.checked = true;
        }
      });
    }

    __groupFields(fields = [], init_values) {
      return [
        {
          multiple: true,
          options: _.map(fields,
        function(field) {
            return {
              id: field.id,
              name: field.title,
              _selected: _.includes(init_values,
        String(field.id))
            };
          })
        }
      ];
    }

  };

  Admin__Messages__SettingsController.include(SettingsPanel, MessageNavActions, ToggleNavMenuAction);

  return Admin__Messages__SettingsController;

}).call(this);
